import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// ─── Security: inject hardening meta tags into <head> ────────────────
const ensureMeta = (attrs: Record<string, string>) => {
  const selector = Object.entries(attrs).map(([k, v]) => `[${k}="${v}"]`).join('');
  if (document.head.querySelector(`meta${selector}`)) return;
  const m = document.createElement('meta');
  Object.entries(attrs).forEach(([k, v]) => m.setAttribute(k, v));
  document.head.appendChild(m);
};
ensureMeta({
  'http-equiv': 'X-Content-Type-Options',
  content: 'nosniff'
});
ensureMeta({
  'http-equiv': 'Referrer-Policy',
  content: 'strict-origin-when-cross-origin'
});
ensureMeta({
  name: 'robots',
  content: 'index, follow, max-image-preview:standard'
});
// Block native drag-save on images (does not impact a11y or screen readers)
document.addEventListener('dragstart', e => {
  const target = e.target as HTMLElement;
  if (target && target.tagName === 'IMG') e.preventDefault();
});
render(<App data-id="element-373" />, document.getElementById('root'));